<div class="row col-12 col-sm-12 mt-4 my-account-container">
  <div class="col-3 col-sm-3 col-md-3 my-account-left-nav">
    @if (bottomSectionPDP==true) {
      <app-facet-navigation></app-facet-navigation>
    }
  </div>
  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <div class="my-section-box">
      @if (true) {
        <form [formGroup]="steeringGearForm">
          <div class="warranty-claim-application-block">
            <h1 class="warranty-claim-headling m-0">
              {{'common.breadcrumb_steeringGear_text'|cxTranslate}}
            </h1>
            <div class="warranty-claim-application-detail">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label selectLabel" for="typeOfOperation">
                      {{ 'common.text_core_submission_product' | cxTranslate }}
                    </label>
                    <div class="control select">
                      <select class="form-control" formControlName="ProductType">
                        <option selected value="Steering_Gears">Steering Gear</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label selectLabel" for="typeOfOperation">
                      {{ 'common.payment_year' | cxTranslate }} *
                    </label>
                    <div class="control select">
                      <select class="form-control" formControlName="Year">
                        <option disabled selected value="null">{{ 'common.form_select_empty' |
                          cxTranslate
                        }}</option>
                        @for (x of (year$ | async); track x) {
                          <option [value]="x.key">{{ x.value }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label selectLabel" for="typeOfOperation">
                      Make*
                    </label>
                    <div class="control select">
                      <select class="form-control" formControlName="Make">
                        <option disabled selected value="null">{{ 'common.form_select_empty' |
                          cxTranslate
                        }}</option>
                        @for (make of (make$ | async); track make) {
                          <option [value]="make.key">{{
                          make.value}}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label selectLabel" for="typeOfOperation">
                      {{ 'common.text_account_warranty_table_header_model' | cxTranslate }}*
                    </label>
                    <div class="control select">
                      <select class="form-control" formControlName="Model">
                        <option disabled selected value="null">{{ 'common.form_select_empty' |
                          cxTranslate
                        }}</option>
                        @for (model of (model$ | async); track model) {
                          <option [value]="model.key">{{
                          model.value }}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <br>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label class="control-label">To Find Your Vehicle Using the VIN Lookup:<br>
                      <a href="https://vpic.nhtsa.dot.gov/decoder/" target="_blank"
                        rel="noopener noreferrer">NTHSA
                      VIN Decoder</a>
                    </label>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 text-right steering-gear-btnBlock">
                    <button type="button" id="steeringReset"
                      class="btn btn-primary steeringReset yellow-btn" name="steeringReset"
                    (click)="steeringGearFormreset()">Reset</button>
                    <button type="type" class="btn btn-primary yellow-btn steering-submit"
                      id="finalSubmit" (click)="onSubmit()"
                      [disabled]="steeringGearForm.invalid">Search <img
                    src="/icons/link-right-white.svg" alt="Link Icon"></button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        }
      </div>

      @if (bottomSectionPDP==true) {
        <div class="bottomSectionPDP">
          <section class="">
            @if (productListService.SteeringProdDetails$|async; as productModel) {
              <div class="container1">
                @if (productModel?.products) {
                  <div class="row1">
                    @if (viewMode$ | async; as viewMode) {
                      <div class="">
                        <div class="cx-sorting top">
                          <div class="action-row sorting-block">
                            <label
                              class="d-none d-md-none d-lg-block col-lg-3 total-records">{{productModel.pagination.totalResults}}
                            {{'common.search_page_totalResults'|cxTranslate}}</label>
                            @if (productModel.pagination.totalResults >90 || productModel.pagination.totalResults >30) {
                              <label class="col-lg-3 pagination"
                                >{{'common.pagination_view'
                                | cxTranslate}}
                                @if (productModel.pagination.totalResults >30) {
                                  <a class="page-size"
                                    [routerLink]="" (click)="changePageSize(30,  productModel)"> &nbsp;30&nbsp;
                                  </a>
                                  } @if (productModel.pagination.totalResults >90) {
                                  <span
                                    >{{'common.pagination_or'|cxTranslate}}
                                    <a class="page-size" [routerLink]=""
                                      (click)="changePageSize(90, productModel)">
                                      &nbsp;90&nbsp;
                                    </a></span>
                                  }
                                {{'common.pagination_items' | cxTranslate}}</label>
                              }
                              <div class="sort-select">
                                <label class="sort-by">
                                  <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                                </label>
                                <div class="col-lg-4 sorting">
                                  <cx-sorting [sortOptions]="productModel.sorts"
                                    (sortListEvent)="sortList($event, productModel)"
                                    [selectedOption]="productModel.pagination?.sort"
                                    [ariaLabel]="'productList.sortResults' | cxTranslate"
                                    ariaControls="product-results-list"
                                    placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                                  </cx-sorting>
                                </div>
                              </div>
                              <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn">
                                <cx-product-view (modeChange)="setViewMode($event)"
                                [mode]="viewMode"></cx-product-view>
                              </div>
                            </div>
                          </div>
                          <div id="product-results-list" class="cx-product-container">
                            <!-- Product list when using pagination -->
                            @if (!isInfiniteScroll) {
                              @if (viewMode === ViewModes.Grid) {
                                <div class="row">
                                  @for (product of productModel?.products; track product) {
                                    <app-kb-product-grid-item
                                      [product]="product"
                                    class="col-12 col-sm-12 col-md-12 col-lg-3 steering-gear-block"></app-kb-product-grid-item>
                                  }
                                </div>
                              }
                              @if (viewMode === ViewModes.List) {
                                @for (product of productModel?.products; track product) {
                                  <app-kb-product-list-item
                                    [product]="product" class="cx-product-search-list">
                                  </app-kb-product-list-item>
                                }
                              }
                            } @else {
                              <cx-product-scroll [scrollConfig]="scrollConfig" [model]="productModel"
                              [inputViewMode]="viewMode"></cx-product-scroll>
                            }
                            <!-- Product list when using infinite scroll -->
                          </div>
                          <div class="cx-sorting bottom">
                            <div class="row col-md-12">
                              <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                                {{(productModel.pagination.pageSize *
                                productModel.pagination.currentPage)+1 }}-
                                @if (productModel.pagination.pageSize *(productModel.pagination.currentPage+1) < productModel.pagination.totalResults) {
                                  <span
                                    >{{productModel.pagination.pageSize
                                  *(productModel.pagination.currentPage+1)}}</span>
                                }
                                @if (productModel.pagination.pageSize *(productModel.pagination.currentPage+1) > productModel.pagination.totalResults) {
                                  <span
                                  >{{productModel.pagination.totalResults}}</span>
                                }
                                {{'common.search_page_of_text'|cxTranslate}}
                                {{productModel.pagination.totalResults}}
                              {{'common.search_page_result_text'|cxTranslate}}</label>
                              @if (!isInfiniteScroll) {
                                <div
                                  class="col-auto col-md-7 d-flex justify-content-end align-items-center pr"
                                        [attr.aria-label]="
                  'productList.productSearchPagination' | cxTranslate
                ">
                                  <div class="kb-pagination">
                                    <kb-pagination [pagination]="productModel.pagination" [defaultPage]="0"
                                    (viewPageEvent)="changePageCustom($event, productModel,2)"></kb-pagination>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (productModel?.pagination?.totalResults ==0) {
                    <p class="row1 mt-4">0 {{'common.search_page_totalResults'| cxTranslate}}</p>
                  }
                </div>
              }
            </section>
          </div>
        }

      </div>
    </div>